export class RulesViewIdentityGuard {
	constructor(layout, i18n, normalizePostId, normalizeUrl) {
		this.layout = layout;
		this.__ = i18n;
		this.normalizePostId = normalizePostId;
		this.normalizeUrl = normalizeUrl;
		this.expectedPostId = null;
		this.expectedUrl = '';
	}

	setExpectedIdentity(page) {
		this.expectedPostId = this.normalizePostId(page?.postId);
		this.expectedUrl = this.normalizeUrl(page?.url || '');
	}

	handleNavigation(navigationData) {
		if (!navigationData || !this.expectedPostId) {
			return false;
		}

		return this.validateIdentity(navigationData.postId, navigationData.url);
	}

	validateIdentity(actualPostId, currentUrl = '') {
		const expectedPostId = this.expectedPostId;

		if (!expectedPostId) {
			return true;
		}

		const normalizedActualPostId = this.resolveActualPostId(actualPostId, currentUrl);

		if (expectedPostId !== normalizedActualPostId) {
			const mismatchUrl = currentUrl || this.expectedUrl;
			this.layout.disableRulesViewToggleButtons();
			this.layout.setStatusError(
				`${this.__( 'Rules view blocked: post ID mismatch for URL.', 'a11yfix' )} ${mismatchUrl} (${this.__( 'Expected', 'a11yfix' )}: ${expectedPostId}, ${this.__( 'Got', 'a11yfix' )}: ${normalizedActualPostId || this.__( 'N/A', 'a11yfix' )})`
			);
			return false;
		}

		this.layout.restoreRulesViewToggleButtonsState();
		const restoredHighlightsCount = this.layout.applyRulesHighlightsFromActiveRules(false);

		if (this.layout.isStatusErrorActive()) {
			if (restoredHighlightsCount > 0) {
				this.layout.setStatus(
					`${this.__( 'Rules view page verified. Highlights restored:', 'a11yfix' )} ${restoredHighlightsCount}`
				);
			} else {
				this.layout.setStatus(
					`${this.__( 'Rules view page verified. Toggle buttons restored.', 'a11yfix' )} ${currentUrl || this.expectedUrl}`
				);
			}
		}

		return true;
	}

	resolveActualPostId(actualPostId, currentUrl) {
		const normalizedActualPostId = this.normalizePostId(actualPostId);

		if (normalizedActualPostId) {
			return normalizedActualPostId;
		}

		return this.extractPostIdFromUrl(currentUrl);
	}

	extractPostIdFromUrl(currentUrl) {
		if (typeof currentUrl !== 'string' || currentUrl.length === 0) {
			return null;
		}

		try {
			const parsedUrl = new URL(currentUrl, window.location.origin);
			const postQueryValue = parsedUrl.searchParams.get('post');

			if (!postQueryValue) {
				return null;
			}

			return this.normalizePostId(postQueryValue);
		} catch {
			return null;
		}
	}
}
